<template>
  <AppLayout>
    <div class="col-12 layout-spacing">
      <div class="widget widget-six">
        <settingsMenu></settingsMenu>

        <div class="widget-heading">
          <div class="row">
            <div class="col-12 d-inline-flex align-items-center">
              <h4 class="me-3 my-0">Ustalone dni wolne</h4>

              <select v-model="wybranyRok" @change="zmienRok"
                      class="form-select form-select-sm w-auto me-3">
                <option v-for="r in lata" :key="r" :value="r">{{ r }}</option>
              </select>

              <button @click="addDzien" class="btn btn-primary btn-sm">
                <i class="bi bi-plus-circle me-2"></i>Dodaj nowy dzień wolny
              </button>
            </div>
          </div>
        </div>

        <div class="widget-content">
		 <div class="row">
		  <div class="col-6">
            <div class="custom-table">
              <div class="table-responsive">
                <table class="table table-hover">
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Dzien wolny od</th>
                      <th>Dzien wolny do</th>
                      <th>Akcje</th>
                    </tr>
                  </thead>
                  <tbody>
			        <tr v-for="(typ, index) in dni_wolne" :key="index">
                      <td>{{ index + 1 }}</td>
                      <td>{{ formatDate(typ.dzien_wolny) }}</td>
                      <td>{{ formatDate(typ.dzien_wolny_do) }}</td>
                      <td>  
                        <button @click="deleteTyp(typ.id)" class="btn btn-sm btn-danger"><i class="bi bi-trash me-2"></i>Usuń</button>
					  </td>
                    </tr>
					<tr v-if="addingNew">
					  <td colspan="4">
						<div class="new-day-picker-container">
						  <label class="form-label mb-1">Wybierz zakres dnia wolnego:</label>
						  <ejs-daterangepicker placeholder="Wybierz daty" :format="'dd/MM/yyyy'" :value="dateRange" :firstDayOfWeek="1" :weekNumber="true" @change="onDateRangeChange"/>
						  <div class="mt-2">
							<button @click="saveDzien" class="btn btn-success btn-sm me-2">Zapisz</button>
							<button @click="cancelNewDzien" class="btn btn-secondary btn-sm">Anuluj</button>
						  </div>
						</div>
					  </td>
					</tr>					
                  </tbody>
                </table>
              </div>
            </div>
          </div>
		   <div class="col-6">
            <label><strong>Dni wolne</strong> to ustalone dni wolne w firmie dla wszystkich pracowników.<br>Zestawienie dni wolnych na dany rok jest widoczne dla pracowników po wejsciu na stronę <strong>Wolne - delegacje</strong>
			oraz dla kierowników działów na stronach z informacjami o urlopach pracowników.</label>
          </div>
		  
		</div>
      </div>
	 </div>
    </div>
  </AppLayout>
</template>

<script>
import AppLayout from "@/Layouts/App.vue";
import { router } from "@inertiajs/vue3";
import settingsMenu from "@/Pages/Kadry/parts/settingsMenu.vue";
import { DateRangePickerComponent } from "@syncfusion/ej2-vue-calendars";

export default {
  components: { AppLayout, settingsMenu, 'ejs-daterangepicker': DateRangePickerComponent },

  props: {
    dni_wolne: Array,
    rok: Number
  },

  data() {
  	const today = new Date();

    return {
      lata: [],
      addingNew: false,
      wybranyRok: null,
      dateRange: [today, today],
      newDzien: this.getEmptyForm()
    };
  },

  created() {
    this.generujLata();
    this.wybranyRok = this.rok;
  },

  methods: {
    getEmptyForm() {
      return {
        dzien_wolny: '',
        dzien_wolny_do: ''
      };
    },

addDzien() {
  this.addingNew = true;
  this.newDzien = this.getEmptyForm();
},
    cancelNewDzien() {
      this.addingNew = false;
      this.newDzien = this.getEmptyForm();
      this.dateRange = this.dateRange = [new Date(), new Date()];
    },

onDateRangeChange(args) {
  if (args.value && args.value.length === 2) {
    const start = args.value[0];
    const end = args.value[1];

    const format = (d) => {
      const year = d.getFullYear();
      const month = String(d.getMonth() + 1).padStart(2, '0');
      const day = String(d.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    };

    this.newDzien.dzien_wolny = format(start);
    this.newDzien.dzien_wolny_do = format(end);
  }
},

saveDzien() {
  if (!this.newDzien.dzien_wolny || !this.newDzien.dzien_wolny_do) {
    alert("Wybierz zakres dat");
    return;
  }

  router.post('/kadry/ustawienia/dni_wolne/dodaj', {
    dzien_wolny: this.newDzien.dzien_wolny,
    dzien_wolny_do: this.newDzien.dzien_wolny_do,
    rok: this.wybranyRok
  }, {
    onSuccess: () => {
      this.cancelNewDzien();
      this.zmienRok(); // przeładuj dni wolne z serwera
    },
    onError: (errors) => {
      alert(errors.dzien_wolny ? errors.dzien_wolny[0] : "Błąd zapisu");
    }
  });
},


    generujLata() {
      const current = new Date().getFullYear();
      this.lata = [];
      for (let i = 5; i >= 0; i--) this.lata.push(current - i);
      this.lata.push(current + 1);
    },

    zmienRok() {
      router.get('/kadry/ustawienia/dni_wolne', { rok: this.wybranyRok });
    },

    formatDate(timestamp) {
      if (!timestamp) return '';
      const date = new Date(timestamp);
      return date.toISOString().split('T')[0];
    },
	    deleteTyp(id) {
      Toast.fire({
        toast: false,
        icon: 'warning',
        title: 'Usuwanie dnia wolnego',
        html: 'Czy na pewno chcesz usunąć wybrany dzień wolny?',
        showDenyButton: true,
        showConfirmButton: true,
        confirmButtonText: 'Tak',
        denyButtonText: 'Nie',
        timer: false,
        position: 'center'
      }).then((result) => {
        if (result.isConfirmed) {
          this.$inertia.delete(route('kadry.dni.wolne.usun', { id }));
        }
      });
    }
  }
};
</script>

<style scoped>
.new-day-picker-container {
  max-width: 400px; /* ograniczona szerokość */
  margin: 10px auto; /* wyśrodkowanie */
  display: flex;
  flex-direction: column;
  gap: 5px;
}
</style>
